

.createNewAddressForm {
  padding: 20px;
  width: 500px;
}

.formRow {
  align-items: center;
  gap: 2rem;
  margin-bottom: 10px;
}

.formRowLabel {
  width: 200px;
}

.subFooter {
  margin: 0 2rem 2rem 2rem;
}

.errorMessageAndFieldContainer {
  width: 100%;
}

.invalidMessage {
  color: var(--sentiment-text-negative);
}